/**
 * SALES-FORECASTING MODULE
 * Self-contained. Import only from /shared or within this module.
 * Do not import from other modules directly.
 */

import { useNavigate } from "react-router-dom";
import { useSession } from "../../../shared/components/SessionProvider.jsx";
import Dashboard from "../components/Dashboard.jsx";

// Sales Forecasting module page. Hosts the ported the source app forecast
// dashboard, wired to the Supabase session + router. Edit access is granted
// to any account member for now (role-gating can layer on later).
export default function Forecasting() {
  const { user } = useSession();
  const navigate = useNavigate();
  return <Dashboard user={user} canEdit={true} onHome={() => navigate("/")} />;
}
